import { render, staticRenderFns } from "./FormError.vue?vue&type=template&id=004a00d1&"
import script from "./FormError.vue?vue&type=script&lang=js&"
export * from "./FormError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('004a00d1')) {
      api.createRecord('004a00d1', component.options)
    } else {
      api.reload('004a00d1', component.options)
    }
    module.hot.accept("./FormError.vue?vue&type=template&id=004a00d1&", function () {
      api.rerender('004a00d1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/global/documentManagement/components/FormError.vue"
export default component.exports